/**
 * Opmaak voor Mijn dag. Het scherm zelf leest uit de lokale opslag
 * (`features/inspections/MyDay*`); hier staan alleen de formatters die het
 * deelt.
 */

/** `108` -> `1 u 48 m`. */
export function formatDuration(minutes: number): string {
    const hours = Math.floor(minutes / 60);
    const rest = minutes % 60;

    if (hours === 0) {
        return `${rest} min`;
    }

    return rest === 0 ? `${hours} u` : `${hours} u ${rest} m`;
}

/** `228589184` -> `218 MB`; de offline-kaart toont hele megabytes. */
export function formatBytes(bytes: number): string {
    return `${Math.round(bytes / (1024 * 1024))} MB`;
}
